import PropTypes from 'prop-types';
import React from 'react';
import { BRAND_NAMES } from '@tcp/core/src/constants/pageTitle.constants';
import PlpTileAnchor from './PlpTileAnchor';
import { ProductTitle, AltPlpProductBrand, AltPlpProductTitle } from './styles/ProductTitle.style';

const ProductTitleHlp = (props) => {
  const {
    productName: productTitle,
    pdpUrl,
    itemAvailability,
    pathName,
    setProductDataForPdp,
    isAltPlpTile,
    brand,
    isTileRedesignAB,
  } = props;

  const getProductTitle = () => {
    const brandName = BRAND_NAMES[brand];
    if (isAltPlpTile) {
      return (
        <>
          <AltPlpProductBrand mh={1}>{brandName}</AltPlpProductBrand>
          <AltPlpProductTitle mh={1}>{productTitle}</AltPlpProductTitle>
        </>
      );
    }
    return <ProductTitle mh={1}>{productTitle}</ProductTitle>;
  };

  return (
    <div className={`product-title-hlp${isTileRedesignAB ? ' tile-redesign' : ''}`}>
      {itemAvailability?.isSoldOut ? (
        <>{productTitle && getProductTitle()}</>
      ) : (
        <PlpTileAnchor
          pathName={pathName}
          pdpUrl={pdpUrl}
          title={productTitle}
          setProductDataForPdp={setProductDataForPdp}
        >
          {productTitle && getProductTitle()}
        </PlpTileAnchor>
      )}
    </div>
  );
};
ProductTitleHlp.propTypes = {
  productName: PropTypes.string,
  pdpUrl: PropTypes.shape({
    asPath: PropTypes.string,
    href: PropTypes.string,
    asPathWithoutSlug: PropTypes.string,
  }),
  itemAvailability: PropTypes.shape({
    isSoldOut: PropTypes.bool,
  }),
};
ProductTitleHlp.defaultProps = {
  productName: '',
  pdpUrl: {},
  itemAvailability: {
    isSoldOut: false,
  },
};
export default ProductTitleHlp;
